import { render, staticRenderFns } from "./DSArrowOppositelyDirectedIcon.vue?vue&type=template&id=2708d1fa&"
import script from "./DSArrowOppositelyDirectedIcon.vue?vue&type=script&lang=js&"
export * from "./DSArrowOppositelyDirectedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports